import { AgGridReact } from 'ag-grid-react';
import React, {
  FC,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataContextModal } from 'src/components/DataContextModal/DataContextModal';
import {
  modelStageDetails,
  modelTableauDetails,
  getContextModal,
  getModalCenterData,
  setModalOpen,
  setCurrentUniqueId,
} from 'src/slices/contextSlice';

import { GridReadyEvent, ICellRendererParams } from 'ag-grid-community';
import './ContextPage.scss';
import { Pagination } from '@scuf/common';
import useWindowSize from 'src/utils/useWindowSize';
import { CustomOverlay, StatusRenderer } from './ContextPage';

const stageData = [
  { stage_id: 'all', name: 'All', selected: true },
  { stage_id: 1, name: 'Stage 1', selected: false, status: 'orange' },
  { stage_id: 2, name: 'Stage 2', selected: false, status: 'orange' },
  { stage_id: 3, name: 'Stage 3', selected: false, status: 'orange' },
];

export const ContextList: FC<{}> = () => {
  const dispatch = useDispatch();
  const gridRef = useRef<any>(null);
  const [gridEvent, setGridEvent] = useState<GridReadyEvent>();
  const gridApi = useMemo(() => gridEvent?.api, [gridEvent]);
  const [modalData, setModalData] = useState<any>({});
  const { width } = useWindowSize();

  const modalOpen = useSelector(getContextModal);

  const {
    model_details: rowData,
    metadata: { page_limit, page, total_row_count },
    loading: gridLoading,
    error: gridError,
  } = useSelector(getModalCenterData);

  // const onStageClick = (stageID: string | number) => {
  //   const updatedStage = stage.map(({ stage_id, ...rest }: any) => ({
  //     ...rest,
  //     stage_id,
  //     selected: stage_id === stageID,
  //   }));
  //   setStage(updatedStage);
  // };

  const handleClose = () => {
    dispatch(setModalOpen(false));
  };

  const onTrainingClick = useCallback(
    (data) => {
      setModalData(data);
      dispatch(
        modelTableauDetails({
          unique_id: data.unique_id,
          model_id: data.model_id,
          stage_id: data.model_stage,
        })
      );
      dispatch(setCurrentUniqueId(data.unique_id));
      dispatch(setModalOpen(true));
    },
    [dispatch]
  );

  const ActionRender = useCallback(
    (params: ICellRendererParams) => {
      switch (params.value) {
        case 'training_required': {
          return (
            <span
              className='training-chip'
              onClick={() => onTrainingClick(params.data)}>
              Training Required
            </span>
          );
        }
        case 'completed': {
          return <span className='completed-chip'>Completed</span>;
        }
        default: {
          return null;
        }
      }
    },
    [onTrainingClick]
  );

  const CustomOverlayParams = useMemo(() => {
    return {
      loading: gridLoading,
      noRecords: rowData.length === 0,
      error: gridError,
    };
  }, [gridError, gridLoading, rowData.length]);

  const onGridReady = (event: GridReadyEvent) => {
    event.api.sizeColumnsToFit();
    setGridEvent(event);
  };

  const onPageChange = (page: number | string) => {
    dispatch(modelStageDetails({ page }));
  };

  useEffect(() => {
    gridApi?.sizeColumnsToFit();
  }, [gridApi]);

  useEffect(() => {
    dispatch(modelStageDetails({}));
  }, [dispatch, modalOpen]);

  useEffect(() => {
    gridApi?.sizeColumnsToFit();
  }, [gridApi, width]);

  useEffect(() => {
    if (gridLoading) gridApi?.showLoadingOverlay();
    else if (rowData.length === 0 || gridError) gridApi?.showNoRowsOverlay();
    else gridApi?.hideOverlay();
  }, [gridApi, gridError, gridLoading, rowData.length]);

  return (
    <div className='context-list-container'>
      <div className='context-table'>
        {/* <div className='header-filter-btn'>
          {stage.map((stageItem) => (
            <Button
              key={stageItem?.stage_id}
              className={`custom-btn ${stageItem?.selected ? 'selected' : ''}`}
              textTransform={false}
              type='secondary'
              content={stageItem?.name}
              disabled={stageItem?.selected}
              icon={
                <span
                  className={`status-dot ${
                    stageItem?.status ? stageItem.status : 'display-none'
                  }`}
                />
              }
              size='small'
              onClick={() => onStageClick(stageItem?.stage_id)}
            />
          ))}
        </div> */}
        <div className='ag-theme-alpine'>
          <AgGridReact
            ref={gridRef}
            domLayout={'autoHeight'}
            rowData={rowData}
            frameworkComponents={{
              StatusRenderer: StatusRenderer,
              ActionRender: ActionRender,
              CustomOverlay: CustomOverlay,
            }}
            columnDefs={[
              {
                field: 'model_name',
                headerName: 'Model Name',
                maxWidth: 350,
                width:350,
                cellClass:'Model_Name'
              },
              {
                field: 'model_stage',
                headerName: 'Model Stage',
                // cellClass: 'align-cell',
                minWidth: 70,
                cellClass:'Model_Stage'
              },
              {
                field: 'model_stage_name',
                headerName: 'Model Stage Name',
                cellClass:'Model_Stage_Name'
              },
              {
                field: 'actions',
                headerName: 'Actions',
                cellRenderer: 'ActionRender',
                cellClass:'Action'
              },
            ]}
            defaultColDef={{
              flex: 1,
              resizable: true,
              sortable: true,
              minWidth: 50,
            }}
            suppressPaginationPanel={true}
            onGridReady={onGridReady}
            overlayLoadingTemplate={'Loading...'}
            noRowsOverlayComponent={'CustomOverlay'}
            noRowsOverlayComponentParams={CustomOverlayParams}
          />
          <Pagination
            totalItems={total_row_count}
            itemsPerPage={page_limit}
            activePage={page}
            onPageChange={onPageChange}
          />
        </div>
      </div>
      {console.log("modalData",modalData)}
      {modalOpen && (
        <div>
          <DataContextModal
            open={modalOpen}
            onClose={handleClose}
            modalHeader={modalData?.model_name ?? ''}
            uniqueId={modalData?.unique_id ?? null}
            statgeId={modalData?.model_stage ?? null}
            modelId={modalData?.model_id ?? null}
          />
        </div>
      )}
    </div>
  );
};

export default ContextList;
